export const selectorWebsite = (state) => state.options.website;
export const selectorWebsites = (state) => state.options.websites;
export const selectorDealer = (state) => state.options.dealer;
export const selectorOptionsError = (state) => state.options.error;
